export default __webpack_public_path__ + "static/media/ball_black_green.474c662b.svg";